import { compose } from 'redux';
import PromotionListExclusiveOffersHandler from 'components/Content/PromotionListHandler/PromotionListExclusiveOffersHandler/PromotionListExclusiveOffersHandler';
import { withPromotionListProps } from 'viewModel/content/promotionList/withPromotionListProps';
import { withPromotionListExclusiveOffersHandlerProps } from 'viewModel/content/promotionList/promotionListExclusiveOffersHandler/withPromotionListExclusiveOffersHandlerProps';

const hoc = compose(withPromotionListProps, withPromotionListExclusiveOffersHandlerProps);

export default hoc(PromotionListExclusiveOffersHandler);
